import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

const EMPTY_FORM = { name: '', cin: '', gstin: '', pan: '', state: '', company_type: 'pvt_ltd' };

function Companies() {
  const [companies, setCompanies] = useState([]);
  const [form, setForm] = useState(EMPTY_FORM);
  const [status, setStatus] = useState({ state: 'loading' });

  const loadCompanies = () => {
    setStatus({ state: 'loading' });
    api
      .get('/companies')
      .then((res) => {
        setCompanies(res.data);
        setStatus({ state: 'ok' });
      })
      .catch((err) => setStatus({ state: 'error', message: err.message }));
  };

  useEffect(() => {
    loadCompanies();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    api.post('/companies', form).then(() => {
      setForm(EMPTY_FORM);
      loadCompanies();
    });
  };

  return (
    <div className="page">
      <h1>Companies</h1>

      <form className="card form-grid" onSubmit={handleSubmit}>
        <input
          placeholder="Company name"
          required
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
        />
        <input
          placeholder="CIN"
          value={form.cin}
          onChange={(e) => setForm({ ...form, cin: e.target.value })}
        />
        <input
          placeholder="GSTIN"
          value={form.gstin}
          onChange={(e) => setForm({ ...form, gstin: e.target.value })}
        />
        <input
          placeholder="PAN"
          value={form.pan}
          onChange={(e) => setForm({ ...form, pan: e.target.value })}
        />
        <input
          placeholder="State"
          value={form.state}
          onChange={(e) => setForm({ ...form, state: e.target.value })}
        />
        <select
          value={form.company_type}
          onChange={(e) => setForm({ ...form, company_type: e.target.value })}
        >
          <option value="pvt_ltd">Private Limited</option>
          <option value="llp">LLP</option>
          <option value="proprietorship">Proprietorship</option>
        </select>
        <button className="btn" type="submit">
          Add company
        </button>
      </form>

      {status.state === 'error' && <p className="error">Backend unreachable: {status.message}</p>}

      <div className="card">
        {companies.length === 0 && status.state === 'ok' && <p>No companies yet.</p>}
        <ul className="company-list">
          {companies.map((c) => (
            <li key={c.id}>
              <Link to="/dashboard">{c.name}</Link>
              <span className="muted"> — {c.company_type}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Companies;
